import * as RdsPartnersActions from '../actions/rdsPartners'

const initialState = {
  isLoading: false,
  error: '',
  rdsPartners: []
}

export default (state = initialState, action) => {
  switch (action.type) {
  case RdsPartnersActions.LOAD_RDSPARTNERS_COMPLETED:
    return {
      ...state,
      isLoading: false,
      rdsPartners: action.data
    }

  case RdsPartnersActions.LOAD_RDSPARTNERS_REQUESTED:
    return {
      ...state,
      isLoading: true
    }

  case RdsPartnersActions.LOAD_RDSPARTNERS_ERROR:
    return {
      ...state,
      isLoading: false,
      error: action.error
    }

  default:
    return state
  }
}


// WEBPACK FOOTER //
// ./src/reducers/rdsPartners.js